export default function genererCritereRecherche() {
  return {
    auto: '',
    datesFacture: {
      dateDebut: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateFin: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
    agencesId: [],
    codesFacture: [],
    etats: [],
    annonceursId: [],
    sousType: [],
    libellesRegroupement: [],
    tiersId: [],
    annonceurs: [],
    bailleurs: [],
  };
}
